import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const authActions = createActionGroup({
    source: 'Auth',
    events: {
        'Login With Pin': props<{ pin: string }>(),
        'Login With Pin Success': props<{ payload: string }>(),
        'Login With Pin Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
